import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent implements OnInit {
  copyright: string;

  ngOnInit() {
    this.copyright = `${(new Date()).getFullYear()} Chevron Corporation. All rights reserved.`;
  }
}
